/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';

export const LoaderPage = () => (
    /* eslint-disable react/sort-comp */
    <div>
        <div className={"build-loader"}>

        </div>
        <div className={"loader-text"}>
            <b> Please wait, Book is Building ! </b>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/loaderPage.js